import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionReferenceData } from '../actions.model';
import { UnresolvedActionReferenceService } from './unresolved-action-reference.service';

export interface ActionReferenceApi {
  loadReferenceData(): Observable<ActionReferenceData>;
}

export const ACTION_REFERENCE_API = new InjectionToken<ActionReferenceApi>(
  'ACTION_REFERENCE_API',
  {
    providedIn: 'root',
    factory: () => inject(UnresolvedActionReferenceService),
  },
);
